import { createMiddleware } from '@shared/redux';
import { showErrorToast, showSuccessToast } from '@shared/toasts/toasts.state';
import { handleApiError } from '@shared/utils/errors';
import {
    GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED as FAKE_GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED,
} from '@domain/dashboard/campaigns/campaigns.state';
import { emptyReport } from '@domain/dashboard/metrics-report/metrics-report.state';
import { getObjectSelectedData, getTypeOfSelectedObject } from '@domain/object-selected';
import { getDashboardFilters } from '@domain/dashboard/dashboard-filters';
import { getEntityId } from '@shared/utils';
import { toApiDateFormat } from '@shared/utils/date';

import {
    EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_FAILED,
    EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_SUCCEEDED,
    GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_FAILED,
    GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED,
    getCampaignsReportsStats,
    HANDLE_GET_CAMPAIGNS_REPORT,
} from './campaigns.state';

export const campaignsMiddleware = createMiddleware({
    [EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_FAILED]: (_, action) => {
        const errorMessage = handleApiError(
            action.payload.response.data.errors
            || action.payload.response.data,
        );
        return showErrorToast({
            message: errorMessage,
            options: { autoClose: 10000 },
        });
    },
    [EDIT_CAMPAIGN_CUSTOMER_ID_REQUEST_SUCCEEDED]: (_, action) => {
        const successMessage = `Successfully changed ${action.requestAction.payload.field}`;
        return showSuccessToast({
            message: successMessage,
        });
    },
    [HANDLE_GET_CAMPAIGNS_REPORT]: (state) => {
        const params = getCampaignStatsParams(state);
        return [getCampaignsReportsStats(params)];
    },
    // TODO Workaround to not break segments
    // related to AB-14987 (Refatoração Segments) and AB-15330 (Criação da tabela do segments)
    // https://dev.azure.com/paretoio/paretech/_sprints/taskboard/Squad%20CCR/paretech/squad-ccr/Q3.S1
    [GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED]: (_, action) => {
        const workaroundSegmentsActionSuccess = () => ({
            ...action,
            type: FAKE_GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_SUCCEEDED,
        });

        return [
            workaroundSegmentsActionSuccess()];
    },
    [GET_CAMPAIGNS_CUSTOMER_ID_REQUEST_FAILED]: () => [emptyReport()],
});

export const getCampaignStatsParams = (state) => {
    const objectSelected = getObjectSelectedData(state);
    const dashboardFilters = getDashboardFilters(state);
    const { ranges: { date: { startDate, endDate } }, conversionType } = dashboardFilters;

    return {
        customerType: getTypeOfSelectedObject(objectSelected),
        customerId: getEntityId(objectSelected),
        startDate: toApiDateFormat(startDate),
        endDate: toApiDateFormat(endDate),
        isNewOverview: true,
        conversionType,
    };
};
